import { render, staticRenderFns } from "./AcquireExperiencePage.vue?vue&type=template&id=b200a332&"
import script from "./AcquireExperiencePage.vue?vue&type=script&lang=js&"
export * from "./AcquireExperiencePage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports